// @ts-nocheck
class HamburgerNav extends HTMLElement {
  connectedCallback() {
    this.trigger = document.querySelector('.hnav__trigger');
    this.overlay = this.querySelector('.hnav__overlay');
    this.links   = this.querySelectorAll('.hnav__link');
    if (!this.trigger || !this.overlay) return;
    this._ac = new AbortController();
    const { signal } = this._ac;

    this.trigger.addEventListener('click', () => {
      this.isOpen ? this.closeMenu() : this.open();
    }, { signal });

    // Close on outside click
    document.addEventListener('click', (e) => {
      if (this.isOpen && !this.overlay.contains(e.target) && !this.trigger.contains(e.target)) {
        this.closeMenu({ restoreFocus: false });
      }
    }, { signal });

    document.addEventListener('keydown', (e) => {
      if (this.isOpen && e.key === 'Escape') {
        e.preventDefault();
        this.closeMenu();
      }
    }, { signal });

    // Disclosure menu, not a modal: close once focus leaves the trigger and the panel.
    document.addEventListener('focusin', (e) => {
      if (this.isOpen && !this.overlay.contains(e.target) && !this.trigger.contains(e.target)) {
        this.closeMenu({ restoreFocus: false });
      }
    }, { signal });
  }

  disconnectedCallback() {
    this._ac?.abort();
  }

  get isOpen() {
    return this.overlay.classList.contains('is-open');
  }

  open() {
    this.overlay.classList.add('is-open');
    this.trigger.classList.add('is-active');
    this.trigger.setAttribute('aria-expanded', 'true');
    this.links.forEach((link, i) => {
      link.style.transitionDelay = `${0.04 + i * 0.05}s`;
    });
  }

  closeMenu({ restoreFocus = true } = {}) {
    this.overlay.classList.remove('is-open');
    this.trigger.classList.remove('is-active');
    this.trigger.setAttribute('aria-expanded', 'false');
    this.links.forEach((link) => {
      link.style.transitionDelay = '0s';
    });
    if (restoreFocus) this.trigger.focus({ preventScroll: true });
  }
}

// The theme editor can load this script again when it re-renders the header.
if (!customElements.get('hamburger-nav')) customElements.define('hamburger-nav', HamburgerNav);
